export default "__VITE_ASSET__Ckut29Cl__"